<aside class="sidebar-wrapper sidebar-shell-card border d-flex flex-column justify-content-between position-relative overflow-hidden">

  <!-- BRAND HEADER -->
  <div class="sidebar-header d-flex justify-content-between align-items-start px-3 pt-2 pb-1">
    <SidebarBrand
      :logo="logo"
      :title="brand_title"
      :subtitle="brand_subtitle"
    />

    <!-- 🔴 MOBILE CLOSE ACTION -->
    <div class="ms-2">
      <slot name="sidebar-header-actions"></slot>
    </div>
  </div>

  <div class="sidebar-divider border-top border-light border-opacity-10 mx-3 my-2"></div>

  <!-- ========== SCROLL AREA ========== -->
  <div class="sidebar-scroll-area flex-grow-1 pb-2">

    <!-- CONTEXT BLOCK -->
    <slot name="context"></slot>


    <!-- MENU BLOCK -->
    <slot name="menu"></slot>

  </div>

  <!-- ========== FOOTER ========== -->
  <div class="sidebar-footer">
    <PlatformSwitcher />

    <SidebarUserFooter
      :initials="initials"
      :full_name="full_name"
    />
  </div>

</aside>
